/**
 * 選択肢の多いバリアントオプション（サイズ等）のアコーディオンを、値を選んだ時点で閉じる。
 *
 * variant-picker.js は change を <variant-picker> 上で受けてから section を fetch → morph する。
 * このリスナーは document（バブリングで後）なので、pill 幅の offsetWidth 計測が終わったあとに走る。
 * morph.js は <details> の open を「古いノードの状態」で上書きするため、ここで先に閉じておけば
 * 再描画後も閉じたままになる。
 */
(function variantAccordion() {
  document.addEventListener('change', (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

    const details = target.closest('details.variant-option__accordion');

    if (!(details instanceof HTMLDetailsElement) || !details.open) return;

    // section の再取得＋morph が終わるまで数百ms〜数秒あるので、選択値は先に反映しておく。
    // （morph 後にサーバー側の値で上書きされる）
    const value = details.querySelector('.variant-option__accordion-value');
    if (value instanceof HTMLElement) value.textContent = target.value;

    details.open = false;

    const summary = details.querySelector('summary');
    if (summary instanceof HTMLElement) summary.focus();
  });
})();
